export default class BillingDealsReportsApi {
    constructor(base) {
        this.base = base;
        this.baseUrl = this.base.cfg.VUE_APP_REPORT_API_BASE_ADDRESS;
        this.billingUrl = this.base.cfg.VUE_APP_TRANSACTIONS_API_BASE_ADDRESS + '/api/billing';

        this.billingsByMonthUrl = this.baseUrl + '/api/reports/billing-deals-by-month';
    }

    async get(params) {
        let data = await this.base.get(this.billingsByMonthUrl, params);
        
        if(!data || data.status === "error")
            return null;

        return data;
    }
}